<template>
  <el-dialog title="上游报价单" :visible.sync="dialogIsShow" width="750px" :close-on-click-modal="false" ref="dialog"
    append-to-body>
    <div class="dia_body">
      <div class="canvasImg" ref="canvasImg">
        <table border="0">
          <tr>
            <th colspan="7" style="height: 50px;font-size: 24px;font-weight: bold;position: relative;">报价单
              <img src="../../../assets/images/splogo.png" class="logo" />
            </th>
          </tr>
          <tr>
            <td colspan="7" style="text-align: left;">
              工控速派（北京）科技服务有限公司
            </td>
          </tr>
          <tr>
            <td colspan="7" style="text-align: left;">
              上海市嘉定区安亭镇墨玉南路969号嘉亭中心2号楼803室</br>电话：021-60956592
            </td>
          </tr>
          <tr>
            <th>ID</th>
            <td colspan="2">{{ (jobBaseInfo && jobBaseInfo.Id) }}</td>
            <th>项目名称</th>
            <td colspan="2">{{ (jobBaseInfo && jobBaseInfo.Title) }}</td>
          </tr>
          <tr>
            <th>客户名称</th>
            <td colspan="2" style="text-align: left;">{{ (jobOtherInfo && jobOtherInfo.CompanyName) }}</td>
            <th>报价日期</th>
            <td colspan="2">{{ (info && info.CreateDate) }}</td>
            <!-- <td colspan="2">--</td>  -->
          </tr>
          <tr>
            <th>地址</th>
            <td colspan="2" style="text-align: left;">{{ (jobBaseInfo && jobBaseInfo.JobAddress) }}</td>
            <th>审核人</th>
            <td colspan="2">{{ (info && info.AuditAdminUserName) }}</td>
          </tr>
          <tr>
            <th>销售</th>
            <td colspan="2">{{ (info && info.SuPaiSalePersonName) }}</td>
            <th>对接</th>
            <td colspan="2">{{ (jobOtherInfo && jobOtherInfo.TakeUserName) }}</td>
          </tr>
          <tr>
            <th>服务内容</th>
            <td colspan="7" style="text-align: left;">
              <div v-html="(jobDetailInfo && jobDetailInfo.Content)"></div>
            </td>
          </tr>
          <tr>
            <th>序号</th>
            <th>计费项</th>
            <th>单价</th>
            <th>单位</th>
            <th>数量</th>
            <th>总价</th>
          </tr>
          <tr>
            <th>1</th>
            <td>人工费</td>
            <td>
              ￥{{ (info && info.ManHourPrice) }}
            </td>
            <td>项 </td>
            <td> {{ (info && info.ManHourCount) }} </td>
            <td>
              ￥{{ (info && info.ManHourAmount) }}
            </td>
          </tr>
          <tr>
            <th>2</th>
            <td>交通费</td>
            <td>
              ￥{{ (info && info.TrafficPrice) }}
            </td>
             <td>项 </td>
            <td>
              {{ (info && info.TrafficCount) }}
            </td>
           
            <td>
              ￥{{ (info && info.TrafficAmount) }}
            </td>
          </tr>
          <tr>
            <th>3</th>
            <td>材料费</td>
            <td>
              ￥{{ (info && info.MateriaPrice) }}
            </td>
             <td>项 </td>
            <td>
              {{ (info && info.MateriaCount) }}
            </td> 
            <td>
              ￥{{ (info && info.MateriaAmount) }}
            </td>
          </tr>
          <tr>
            <th>4</th>
            <td>其他费用</td>
            <td> ￥{{ (info && info.OtherPrice) }} </td>
             <td>项 </td>
            <td>
              {{ (info && info.OtherCount) }}
            </td> 
            <td>
              ￥{{ (info && info.OtherAmount) }}
            </td>
          </tr>
          <tr>
            <th>合计(含税6%)</th>
            <td colspan="3" style="text-align: left;">
              ￥{{ (info && info.TotalAmount) }}
            </td>
            <th>计费类别</th>
            <td style="padding:10px 5px;">
              {{ ((info && info.BillType == 0) ? "按天" : "整包") }}
            </td>
          </tr>
          <tr>
            <th>备注</th>
            <td colspan="7" style="text-align: left;">
              <div v-html="(info && info.OfferRemark)"></div>
            </td>
          </tr>
          <tr>
            <th>工程周期</th>
            <td colspan="7" style="text-align: left;">见备注</td>
          </tr>
          <tr v-if="(info && info.BillType == 1)">
            <th>付款节点</th>
            <td colspan="1">付款金额</td>
            <td colspan="1">百分比</td>
            <td colspan="3">支付条件</td>
          </tr>
          <tr v-if="(info && info.BillType == 1)">
            <th>预付款</th>
            <td>
              ￥{{ (info && info.PrepayAmount) }}
            <td>
              {{ (info && info.PrepayAmountPercent) }}%
            </td>
            <td colspan="3">进场前1天内支付</td>
          </tr>
          <tr v-if="(info && info.BillType == 1)">
            <th>结束支付</th>
            <td>
              ￥{{ (info && info.EndAmount) }}
            </td>
            <td>
              {{ (info && info.EndAmountPercent) }}%
            </td>
            <td colspan="3">施工完成后7个工作内支付</td>
          </tr>

          <tr>
            <td colspan="7" style="text-align: left;">
              1.此表格用于确认服务预估费用，最终结算费用以速派与发单方确认的现场实际发生费用为准；</br>
              2.如发单方无法提供现场情况造成无法提前预估费用，则最终费用以速派与发单方确认的现场实际发生费用为准；</br>
              3.现场实际发生费用以业主签字的服务工单为准。
            </td>
          </tr>
        </table>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="copyImg">复制图片</el-button>

      <el-button type="primary" size="small" @click="dialogIsShow = false;">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import html2canvas from 'html2canvas';
import { JobUpOffer, JobDownOffer, GetJobSupaiSalePerson } from "@/service/job";
export default {
  data() {
    return {
      dialogIsShow: false,
      jobId: 0,

      info: null,//报价信息，
      jobOtherInfo: null,
      jobBaseInfo: null,
      jobDetailInfo: null,
    };
  },
  created() { },

  methods: {
    openDia(info, jobOtherInfo, jobBaseInfo, jobDetailInfo) {
      this.dialogIsShow = true;

      this.info = info;
      console.log('offerRamrk:'+info.OfferRemark)
      if (info.OfferRemark) {
        info.OfferRemark = info.OfferRemark.replace(/\r/g, '<br/>');
        info.OfferRemark = info.OfferRemark.replace(/\n/g, '<br/>');
      }



      this.jobOtherInfo = jobOtherInfo;
      this.jobBaseInfo = jobBaseInfo;
      this.jobDetailInfo = Object.assign({}, jobDetailInfo);

      if (this.jobDetailInfo && this.jobDetailInfo.Content) {
        this.jobDetailInfo.Content = this.jobDetailInfo.Content.replace(/\r/g, '<br/>');
      }

      console.log("this.dialogIsShow:" + this.dialogIsShow);
    },

    //复制图片
    async copyImg() {
      try {
        const canvas = await html2canvas(this.$refs.canvasImg) // 在这里，将需要转换成图片的部分作为参数传入html2canvas
        const image = canvas.toDataURL() // 将生成的canvas转换为DataURL格式
        this.imgUrl = image;
        console.log(image) // 可以将image自行存储

        const data = await fetch(this.imgUrl);
        const blob = await data.blob();

        await navigator.clipboard.write([
          new ClipboardItem({
            [blob.type]: blob,
          }),
        ]);

        return this.$message.success('已复制')

      } catch (e) {
        throw new Error(e)
      }

    },

  }
};
</script>

<style scoped lang="scss">
.dia_body {
  input[aria-hidden="true"] {
    display: none !important;
  }

  .canvasImg {
    // border: 1px solid red;
    padding: 5px;
  }

  table {
    border-collapse: collapse;
    width: 100%;
  }

  table th {
    width: 115px;
    // border: 0.5px solid black;
    text-align: center;
    padding: 5px;
    vertical-align: middle;
    border: 1px solid #ebeef5;
    //  border: 1px solid #ebeef5;
  }

  table td {
    padding: 5px;
    text-align: center;
    border: 1px solid #ebeef5;
  }

  img.logo {
    width: 150px;
    position: absolute;
    right: 10px;
    top: 10px;
  }
}
</style>